module.exports = __webpack_public_path__ + "img/zhenghanzu.8a288baa.jpg";